<template>
  <div class="details-view">
    <cargo-left-right-resize
      :left-style="{flex:'none','max-width':'190px'}"
      :right-style="{'overflow': 'hidden'}"
      :show-left="action==='look'"
      style="min-height:100%"
    >
      <template slot="left">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :row-data="rowData"
          :check-sub-record="false"
          :check-main-record="false"
          :deselect-main-record="false"
          :deselect-sub-record="false"
          class="section"
          style="min-width: 160px;width:100%;height:100%;"
          @gridReady="params=>{gridApi=params.api}"
        />
      </template>
      <template slot="right">
        <div class="main-content">
          <div class="operations" style="margin-bottom: 5px">
            <div class="triggers">
              <cargo-button-group-slider>
                <div v-show="action==='look'">
                  <el-button type="primary" @click="backEventFlag=true">{{ $t('common.btn.back') }}</el-button>
                  <el-button :disabled="!(currentRow && currentRow.jobState == -1 && !isEditing)" type="primary" @click="onAdd()">{{ $t('common.btn.new') }}</el-button>
                  <!--编辑-->
                  <el-button type="success" @click="toEdit">{{ $t('common.btn.edit') }}</el-button>
                  <el-button :disabled="!(currentRow && currentRow.jobState === -1 && !isEditing)" type="primary" @click="copyJobHandler()">{{ $t('SeaExport.Clone') }}</el-button>
                  <!--审核通过-->
                  <el-button v-show="!isCooperate" :disabled="!(currentRow && currentRow.jobState === -1 && !isEditing && (currentRow.preverifyState !== 5 && currentRow.preverifyState !== 2 && currentRow.preverifyState !== 3))" type="primary" @click="acceptHandler(1)">{{ $t('SeaExport.PassAudit') }}</el-button>
                  <!--拒绝-->
                  <el-button v-show="!isCooperate" :disabled="!(currentRow && currentRow.jobState === -1 && !isEditing && (currentRow.preverifyState !== 5 && currentRow.preverifyState !== 2 && currentRow.preverifyState !== 3))" type="primary" @click="rejectHandler(1)">{{ $t('SeaExport.Refuse') }}</el-button>
                  <!--协作状态: 审核通过-->
                  <el-button v-show="isCooperate" :disabled="!(currentRow && !isEditing && [SystemConstants.COOPERATE_STATUS_PENDING.code].includes(currentRow.cooperateStatus))" type="primary" @click="acceptCooperateHandler(1)">{{ $t('SeaExport.PassAudit') }}</el-button>
                  <!--协作状态: 拒绝-->
                  <el-button v-show="isCooperate" :disabled="!(currentRow && !isEditing && [SystemConstants.COOPERATE_STATUS_PENDING.code].includes(currentRow.cooperateStatus))" type="primary" @click="rejectHandler(1)">{{ $t('SeaExport.Refuse') }}</el-button>
                  <!--复核通过-->
                  <el-button v-show="!isCooperate && $checkPermission(['button_reVerify_reviewThrough']) && pretrialReviewConfig" :disabled="!(currentRow && currentRow.jobState === -1 && !isEditing && currentRow.preverifyState === 2)" type="primary" @click="btVerifyReviewThroughHandler(1)">{{ $t('SeaExport.VerifyReviewThrough') }}</el-button>
                  <!--复核拒绝-->
                  <el-button v-show="!isCooperate && $checkPermission(['button_reVerify_reviewRefusal']) && pretrialReviewConfig" :disabled="!(currentRow && currentRow.jobState === -1 && !isEditing && currentRow.preverifyState === 2)" type="primary" @click="btVerifyReviewRefusalHandler(1)">{{ $t('SeaExport.VerifyReviewRefusal') }}</el-button>
                  <!--日志记录-->
                  <el-dropdown
                    no="logHandle"
                    split-button
                    type="primary"
                    style="margin-left: 5px;"
                    @click="logHandle()"
                    @command="p=>{logCommand=p;logHandle()}"
                  >
                    {{ $t('CargoMsg.Cargo_LogRecord') }}
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        :command="$t('SeaExport.PortDataPushLog')"
                      >{{ $t('SeaExport.PortDataPushLog') }}</el-dropdown-item>
                      <el-dropdown-item
                        :command="$t('CargoMsg.Cargo_BusinessStatusChangeLog')"
                      >{{ $t('CargoMsg.Cargo_BusinessStatusChangeLog') }}</el-dropdown-item>
                      <el-dropdown-item
                        :command="$t('SeaExport.EdiStatusChangeLog')"
                      >{{ $t('SeaExport.EdiStatusChangeLog') }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div v-show="isNew" class="new" style="border-left:none;padding-left:0">
                  <el-button type="success" @click="save">{{ $t('common.btn.save') }}</el-button>
                  <el-button type="success" @click="cancelEdit(goBack)">{{ $t('common.btn.cancel') }}</el-button>
                  <el-button no="SaveTheDefaultValues" type="primary" @click="saveDefaultVal">{{ $t('SeaExport.SaveTheDefaultValues') }}</el-button>
                </div>
                <div v-show="action==='edit'" class="btn-group-edit" style="border-left:none;padding-left:0">
                  <el-button type="success" @click="save">{{ $t('common.btn.save') }}</el-button>
                  <el-button
                    type="success"
                    @click="cancelEdit(lookHandler)"
                  >{{ $t('common.btn.cancel') }}</el-button>
                  <el-button no="SaveTheDefaultValues2" type="primary" @click="saveDefaultVal">{{ $t('SeaExport.SaveTheDefaultValues') }}</el-button>
                </div>
              </cargo-button-group-slider>
              <div v-show="action==='look'||action==='edit'" style="display: flex; white-space: nowrap;">
                <el-tooltip effect="dark" :content="action==='edit' ? '' : $t('SeaExport.Tip1')" placement="bottom-start" :offset="sopTooltipOffset" :visible-arrow="false">
                  <div style="width: 100%;cursor: pointer" @mousemove="resetSopTooltip" @dblclick="onBtnListDoubleClicked()">
                    <span class="red" style="font-size:14px;padding:5px 0">{{ commonInfo.jobState }}</span>
                    <span style="font-size:12px;padding: 5px 9px;color:unset;" v-html="commonInfo.jobTitle" />
                    <span class="red" style="font-size:12px;padding:5px 0">{{ commonInfo.jobLock }}</span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="tabs-container">
            <el-tabs
              ref="tabs"
              v-model="activeTabName"
              type="card"
              :before-leave="(activeName,oldActiveName)=>{beforeLeaveTab(activeName,oldActiveName)}"
              style="width:100%;"
              @tab-click="handleTabClick"
            >
              <el-tab-pane
                v-if="!masterFlag && privilege.reBooking.bookingTab"
                :key="1"
                :lazy="true"
                name="tabBookingFCL"
                :label="$t('SeaExport.Basic')"
              >
                <tab-booking-fcl ref="tabBookingFCL" :context="context" :action="action" :cooperate-edit="cooperateEditOther" :processing-promise-list="processingPromiseList" />
              </el-tab-pane>
              <el-tab-pane
                v-if="masterFlag && privilege.reBooking.bookingTab"
                :key="2"
                :lazy="true"
                name="tabBookingMaster"
                :label="$t('SeaExport.Basic')"
              >
                <tab-booking-master
                  ref="tabBookingMaster"
                  :context="context"
                  :action="action"
                  view-source="bookingWorkspace"
                  :cooperate-edit="cooperateEditOther"
                  @addLcl="addBatchLcl"
                  @selectJob="jobUuid=>{transferTargetRow('edit', jobUuid)}"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @removeJob="removeJob"
                />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.warehousing && privilege.reBooking.warehouseTab"
                :key="3"
                :lazy="true"
                name="tabWarehouse"
                :label="$t('SeaExport.WarehouseLoading')"
              >
                <tab-warehouse ref="tabWarehouse" :context="context" :action="action" :cooperate-edit="cooperateEditWarehouse" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.landTransportation && privilege.reBooking.reTruckingPage"
                :key="4"
                :lazy="true"
                name="tabTrucking"
                :label="$t('SeaExport.Trucking')"
              >
                <tab-trucking ref="tabTrucking" :context="context" :action="action" :cooperate-edit="cooperateEditTrucking" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !masterFlag && privilege.reBooking.containersLayer"
                :key="5"
                :lazy="true"
                name="tabContainer"
                :label="$t('SeaExport.ContainerInfo')"
              >
                <tab-container ref="tabContainer" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && masterFlag && !isNew && privilege.reBooking.lclManagerLayer"
                :key="6"
                :lazy="true"
                name="tabLclContainer"
                :label="$t('SeaExport.ContainerInfo')"
              >
                <tab-lcl-container
                  ref="tabLclContainer"
                  :context="context"
                  :action="action"
                  :cooperate-edit="cooperateEditOther"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @split="splitHandle"
                />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && privilege.charge.chargeView"
                :key="7"
                :lazy="true"
                name="tabTradeDetail"
                :label="$t('SeaExport.TradeDetail')"
              >
                <tab-trade-detail ref="tabTradeDetail" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.customs && privilege.reBooking.reCustomsInfo"
                :key="8"
                :lazy="true"
                name="tabCustomsInfo"
                :label="$t('SeaExport.CustomsDeclaration')"
              >
                <tab-customs-info ref="tabCustomsInfo" :context="context" :action="action" :cooperate-edit="cooperateEditCustoms" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.itmService"
                :key="9"
                :lazy="true"
                name="tabTradeCommission"
                :label="$t('SeaExport.TradeCommission')"
              >
                <tab-trade-commission ref="tabTradeCommission" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.headwayTail && privilege.reBooking.headwayTail"
                :key="10"
                :lazy="true"
                name="tabRailwayHeadwayTail"
                :label="$t('RailwayExport.isHeadwayTail')"
              >
                <tab-railway-headway-tail
                  ref="tabRailwayHeadwayTail"
                  :context="context"
                  :action="action"
                  :cooperate-edit="cooperateEditOther"
                />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && privilege.charge.chargeView"
                :key="11"
                :lazy="true"
                name="tabCharges"
                :label="$t('SeaExport.Charge')"
              >
                <tab-charges ref="tabCharges" :context="context" :action="action" view-source="RailwayVerify" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && privilege.chargeConfirm.chargeConfirmView"
                :key="12"
                :lazy="true"
                name="tabInternalBill"
                :label="$t('SeaExport.InternalBillInfo')"
              >
                <tab-internal-bill ref="tabInternalBill" :context="context" :action="action" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && privilege.billTab.billTabView"
                :key="13"
                :lazy="true"
                name="tabOverseaBill"
                :label="$t('SeaExport.OverseaBillInfo')"
              >
                <tab-oversea-bill ref="tabOverseaBill" :context="context" :action="action" view-source="RailwayVerify" @refreshCharges="refreshCharges" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && privilege.charge.advanceCharge"
                :key="14"
                :lazy="true"
                name="tabAdvanceCharge"
                :label="$t('SeaExport.AdvanceChargeInfo')"
              >
                <tab-advance-charge ref="tabAdvanceCharge" :context="context" :action="action" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && privilege.reBooking.portalState"
                :key="15"
                :lazy="true"
                name="tabSopState"
                :label="$t('SeaExport.BusinessStatus')"
                :cooperate-edit="cooperateEditOther"
              >
                <tab-sop-state ref="tabSopState" :context="context" :action="action" :sop-template-config="sopTemplateConfig" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && privilege.fileHistory.fileHistoryView"
                :key="16"
                :lazy="true"
                name="tabFileHistory"
                :label="$t('SeaExport.FileHistory')"
                :cooperate-edit="cooperateEditOther"
              >
                <tab-file-history ref="tabFileHistory" :context="context" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <!-- SOP操作状态弹窗 -->
    <sop-state-dialog :hide-window="isEditing" :visible.sync="sopStateDialog.visible" :is-need-refresh.sync:="sopStateDialog.isNeedRefresh" :default-is-expand="sopStateDialog.defaultIsExpand" :job="job" :is-need-expand.sync="sopStateDialog.isNeedExpand" @handleClose="sopStateDialogClose" />
    <!-- 订舱审核-通过 -->
    <op-verify-frame-dialog
      v-if="opVerifyFrameDialog.visible"
      :visible.sync="opVerifyFrameDialog.visible"
      :job-model="opVerifyFrameDialog.job || {}"
      :batch-pass-audit="opVerifyFrameDialog.batchPassAudit"
      :submit-call-back="opVerifyFrameDialog.submitCallBack"
      :job-list="opVerifyFrameDialog.jobList || []"
    />
    <!-- 订舱审核-拒绝 -->
    <op-verify-frame-reject
      v-if="rejectWindow.visible"
      :visible.sync="rejectWindow.visible"
      :job-no="rejectWindow.jobNo"
      :reject-call-back="rejectWindow.rejectCallBack"
    />
    <!-- 预估利润率验证弹窗-->
    <estimate-validation-dialog
      ref="estimateValidationDialog"
      :visible.sync="estimateValidationDialog.visible"
      :job="estimateValidationDialog.job"
      :estimate-profit-rate="estimateValidationDialog.estimateProfitRate"
      :tatol-profit="estimateValidationDialog.tatolProfit"
      @callback="estimateValidationDialog.callback"
    />
    <!-- 信控验证弹框 -->
    <confirm-dialog-window
      v-if="confirmDialogWindow.visible"
      :visible.sync="confirmDialogWindow.visible"
      :message-title="confirmDialogWindow.messageTitle"
      :content="confirmDialogWindow.content"
      :show-confirm-btn="confirmDialogWindow.showConfirmBtn"
      :confirm-call-back="confirmDialogWindow.confirmCallBack"
    />
    <!-- 数据推送变更记录弹窗 -->
    <el-dialog
      v-if="dataPushDialog.visible"
      v-el-drag-dialog
      no="DataPushChangeLog"
      :visible.sync="dataPushDialog.visible"
      :title="$t('SeaExport.DataPushChangeLog')"
      width="580px"
      :close-on-click-modal="false"
      class="app-main-inner"
      @close="dataPushDialog.visible=false"
    >
      <div
        class="app-main-inner-row"
        style="padding: 0;display: flex;flex-direction: column"
        :style="{width:'100%',height:'400px',overflow:'auto'}"
      >
        <div v-for="(title,index) in dataPushDialog.titles" :key="index">
          <div style="background:#EBECF5">
            <b>{{ title }}</b>
          </div>
          <div v-for="(item,index) in dataPushDialog.dataMap.get(title)" :key="index">
            <div>{{ item }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 业务状态变更记录弹窗 -->
    <business-status-log-dialog
      v-if="businessStatusDialog.visible"
      :visible.sync="businessStatusDialog.visible"
      :job-uuid="currentRow.uuid || ''"
    />
    <!-- EDI状态变更记录弹窗 -->
    <edi-status-log-dialog
      v-if="ediStatusLogDialog.visible"
      :visible.sync="ediStatusLogDialog.visible"
      :job-uuid="currentRow.uuid || ''"
    />
    <!-- 协作状态审核 -->
    <cooperation-verify-dialog
      v-if="cooperationVerifyDialog.visible"
      :visible.sync="cooperationVerifyDialog.visible"
      :job-uuid="cooperationVerifyDialog.jobUuid"
      :cooperate="cooperationVerifyDialog.cooperate"
      :submit-call-back="cooperationVerifyDialog.submitCallBack"
      :editable="cooperationVerifyDialog.editable"
    />
    <!-- 多条业务，配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      lob="RE"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
      :new-job="batchCheckingWindow.newJob"
    />
    <!-- 单条业务，配置规则验证弹窗-->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="RE"
      :job="job"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
      :call-back2="checkingWindow.callBack2"
      :new-job="checkingWindow.newJob"
    />
  </div>
</template>

<script>
import { VerifyWorkspaceContext } from './verifyWorkspaceContext'
import { VerifyWorkspacePM } from './verifyWorkspacePM'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import URL from '@/api/urlTranslator'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import tabBookingFcl from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingFCL'
import tabBookingMaster from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingMaster'
import tabWarehouse from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabWarehouse'
import tabTrucking from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabTrucking'
import tabContainer from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabContainer'
import tabLclContainer from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabLclContainer'
import tabTradeDetail from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabTradeDetail'
import tabCustomsInfo from '@/components/Cargo/Job/booking/tabs/tabCustomsInfo'
import tabTradeCommission from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabTradeCommission'
import tabRailwayHeadwayTail from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabRailwayHeadwayTail'
import tabCharges from '@/components/Cargo/Job/booking/tabs/tabCharges'
import tabInternalBill from '@/components/Cargo/Job/booking/tabs/tabInternalBill'
import tabOverseaBill from '@/components/Cargo/Job/booking/tabs/tabOverseaBill'
import tabAdvanceCharge from '@/components/Cargo/Job/booking/tabs/tabAdvanceCharge'
import tabSopState from '@/components/Cargo/Job/booking/tabs/tabSopState'
import tabFileHistory from '@/components/Cargo/Job/booking/tabs/tabFileHistory'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import CheckingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow'
import EstimateValidationDialog from '@/components/Cargo/Job/estimateValidationDialog'
import { TabError } from '@/utils/class/TabError'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import { Company } from '@/class/model/mdm/Company'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { ensureExecuteSuccess, deepCopy, sleep, catchErrorTip } from '@/utils/commonUtil'
import { sortByMultiField } from '@/utils'
import DateUtils from '@/utils/dateUtils'
import { saveRailwayExport, saveCopyJob, approved, preVerifyReject } from '@/api/railwayExport/reBooking'
import { batchCheckJobsCredit } from '@/api/booking/job'
import sopStateDialog from '@/components/Cargo/Job/sopStateDialog'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import DropUploader from '@/components/Cargo/Common/DropUploader'
import OpVerifyFrameDialog from '@/views/cargo/v0/RailwayExport/components/verify/OpVerifyFrameDialog'
import ConfirmDialogWindow from '@/views/cargo/v0/RailwayExport/components/verify/ConfirmDialogWindow'
import OpVerifyFrameReject from '@/views/cargo/v0/RailwayExport/components/verify/OpVerifyFrameReject'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import businessStatusLogDialog from '@/views/cargo/v0/Clearing/components/financeManage/businessStatusLogDialog'
import ediStatusLogDialog from '@/components/Cargo/Job/ediStatusLogDialog'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import cooperationVerifyDialog from '@/components/Cargo/Job/cooperationVerifyDialog'
import { updateState } from '@/api/booking/jobCooperate'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { getCreditInfoByJobUuid } from '@/api/partner/creditInfo'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'
import { getSopTemplateConfig } from '@/api/sysManage/baseConfig/businessManage'

export default {
  name: 'VerifyWorkspace',
  components: {
    CargoButtonGroupSlider,
    OpVerifyFrameDialog,
    OpVerifyFrameReject,
    ConfirmDialogWindow,
    DropUploader,
    cargoAdvanceSelect, cargoUserSelect, cargoLeftRightResize,
    tabBookingFcl, tabBookingMaster, tabWarehouse, tabTrucking, tabContainer, tabLclContainer, tabTradeDetail, tabCustomsInfo,
    tabTradeCommission, tabRailwayHeadwayTail, tabCharges, tabInternalBill, tabOverseaBill, tabAdvanceCharge, tabSopState, tabFileHistory,
    CheckingWindow,
    EstimateValidationDialog,
    BatchCheckingWindow,
    sopStateDialog,
    businessStatusLogDialog,
    ediStatusLogDialog,
    cooperationVerifyDialog
  },
  props: {
    parentContext: {
      type: Object,
      required: true
    },
    useOrderCenterMode: { type: Boolean, default: false },
    approveCooperationBusiness: { type: Boolean, default: false }
  },
  data() {
    return {
      URL,
      selectTypeNames: TYPE_NAMES,
      context: new VerifyWorkspaceContext(this.parentContext),
      pm: new VerifyWorkspacePM(this),
      SystemConstants,
      copyJobNum: 0,
      privilege: {
        reBooking: {
          bookingTab: this.$checkPermission(['tab_REBooking_BookingTab']),
          warehouseTab: this.$checkPermission(['tab_REBooking_WarehouseTab']),
          reTruckingPage: this.$checkPermission(['tab_REBooking_RETruckingPage']),
          containersLayer: this.$checkPermission(['tab_REBooking_ContainersLayer']),
          lclManagerLayer: this.$checkPermission(['tab_REBooking_LclManagerLayer']),
          reCustomsInfo: this.$checkPermission(['tab_REBooking_RECustomsInfo']),
          headwayTail: this.$checkPermission(['tab_REBooking_headwayTail']),
          portalState: this.$checkPermission(['tab_REBooking_portalState'])
        },
        charge: {
          chargeView: this.$checkPermission(['tab_Charge_chargeView']),
          advanceCharge: this.$checkPermission(['tab_Charge_advanceCharge'])
        },
        chargeConfirm: {
          chargeConfirmView: this.$checkPermission(['tab_ChargeConfirm_chargeConfirmView'])
        },
        billTab: {
          billTabView: this.$checkPermission(['tab_billTab_billTabView'])
        },
        fileHistory: {
          fileHistoryView: this.$checkPermission(['tab_FileHistory_fileHistoryView'])
        }
      },
      commonInfo: {
        operateNameCode: -1, // 操作code
        jobState: '',
        jobTitle: '',
        invoiceMode: '',
        jobLock: '',
        isCopySellingCharge: false, // 复制应付费用
        needConfirmDuplicateWarehouseNo: false, // 是否要验证进仓编号重复
        synchronousShipperCodeAndConsigneeCodeAndNotifyCode: false, // 提单收发通代码是否同步至基本页签收发通代码
        isPrint: true,
        isPrintOpr: false, // 是否打印操作（由于打印和提交中最后调用的有相同的方法，因此用改参数区分开来）
        detailTitleShowModel: 0, // 标题显示模式
        printEvent: null,
        showMessage: true
      },
      sopTooltipOffset: 0,
      action: '',
      backEventFlag: false, // 返回事件标识
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        suppressContextMenu: true,
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 160,
          tooltip: (params) => {
            return params.data ? params.data.jobNo : ''
          },
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            innerRenderer: params => {
              return `<span>${params.value}</span>`
            }
          },
          suppressMenu: true
        },
        columnDefs: [],
        context: {
          componentParent: this
        },
        onRowClicked: this.changeJob
      },
      rowData: [],
      gridApi: null,
      currentRow: {},
      paramsOfTab: {},
      pendTabSet: new Set(),
      isRefresh: false,
      activeTabName: '',
      partner: {}, // 发送分公司-合作伙伴
      relatedJobUUID: '', // 跨tenant委托，接收方的jobUuid
      template: {}, // 跨tenant委托后调用模板，上传到云存储
      lob: 'RE',
      sopStateDialog: {
        visible: false,
        isNeedRefresh: false,
        job: {},
        defaultIsExpand: false,
        isNeedExpand: false
      },
      isGetNewJobInfoFromDb: false, // 是否从数据库里获取最新job相关信息【暂时用于保存之后取job】
      estimateValidationDialog: {
        visible: false,
        job: { estimateAccountsReceivable: 0, estimateAccountsPayable: 0, estimateGrossProfit: 0, situation: '' },
        estimateProfitRate: 0,
        tatolProfit: 0,
        callback: () => {}
      },
      rejectWindow: {
        visible: false,
        jobNo: '',
        rejectCallBack: null,
        type: 0 // 0  =  列表审核通过 1  =  在详情页面审核通过
      },
      opVerifyFrameDialog: { // 审核通过
        visible: false,
        batchPassAudit: false,
        job: null,
        jobList: [],
        result: null, // 审核通过界面所填写的值
        verifyType: 1, // 订舱预审-审核通过类型
        type: 0, // 0  =  列表审核通过 1  =  在详情页面审核通过
        submitCallBack: null
      },
      batchJobList: [], // 批量审核通过的业务列表
      confirmDialogWindow: { // 信控验证使用
        visible: false,
        messageTitle: '',
        content: '',
        confirmCallBack: null,
        showConfirmBtn: ''
      },
      isOtherEdit: false, // 拆分主票，复制业务，都属于新增的数据，uuid为空，但是大部分字段已经有值，不需要走初始化数据操作
      logCommand: this.$t('SeaExport.PortDataPushLog'),
      dataPushDialog: {
        visible: false,
        titles: [],
        dataMap: new Map()
      },
      businessStatusDialog: {
        visible: false
      },
      ediStatusLogDialog: {
        visible: false
      },
      cooperationVerifyDialog: {
        visible: false,
        jobUuid: '',
        cooperate: null,
        submitCallBack: this.toAcceptCooperationVerifyCallBack,
        editable: true
      },
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null,
        newJob: null
      },
      checkingWindow: {
        visible: false,
        checkNode: 0,
        callBack: null,
        callBack2: null,
        newJob: null
      },
      pretrialReviewConfig: false,
      defaultJob: null,
      processingPromiseList: [], // 正在处理中的异步操作对象列表
      sopTemplateConfigRE: {}, // SOP模板配置(铁路出口)
      sopTemplateConfigRI: {} // SOP模板配置(铁路进口)
    }
  },
  computed: {
    user() {
      return this.context.user
    },
    office() {
      return this.context.office
    },
    config() {
      return this.context.config
    },
    isNew() {
      return this.action === 'add' || this.action === 'split' || this.action === 'copy'
    },
    isEditing() {
      return this.action !== 'look'
    },
    masterFlag() {
      return this.paramsOfTab.masterFlag
    },
    isLclMaster() {
      return !!this.paramsOfTab.lclMasterUuid
    },
    job() {
      return this.currentRow
    },
    orderCenterBranch() { // 是否接单分公司
      return this.cooperateStatus === -1
    },
    cooperateBranchId() { // 协作分公司
      return this.$store.getters.currentOfficeId
    },
    cooperateStatus() {
      let cooperateStatus = this.paramsOfTab.cooperateStatus === undefined || this.paramsOfTab.cooperateStatus === null ? -1 : this.paramsOfTab.cooperateStatus
      if (this.paramsOfTab.cooperateCooperateStatus) {
        cooperateStatus = this.paramsOfTab.cooperateCooperateStatus
      }
      return cooperateStatus
    },
    cooperateBusinessTypeCode() {
      let cooperateBusinessTypeCode = this.paramsOfTab.cooperateBusinessTypeCode || ''
      if (!cooperateBusinessTypeCode && this.paramsOfTab.cooperateBusinessType) {
        cooperateBusinessTypeCode = this.paramsOfTab.cooperateBusinessType
      }
      return cooperateBusinessTypeCode
    },
    cooperateEditCustoms() { // 报关
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Customs')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditTrucking() { // 陆运
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Trucking')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditBooking() { // 订舱
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Booking')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditWarehouse() { // 仓储
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Warehouse')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditOther() { // 其他
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      if (this.orderCenterBranch) return true
      return false
    },
    isCooperate() { // 是否协作业务
      console.log('this.paramsOfTab.cooperateUuid', this.paramsOfTab.cooperateUuid)
      if (this.useOrderCenterMode && !this.orderCenterBranch && this.paramsOfTab.cooperateUuid) {
        return true
      }
      return false
    },
    sopTemplateConfig() {
      return this.job.lob === 'RE' ? this.sopTemplateConfigRE : this.sopTemplateConfigRI
    }
  },
  watch: {
    backEventFlag(newVal) {
      if (newVal) {
        this.backEventFlag = false
        return catchErrorTip(() => {
          return this.goBack()
        })
      }
    }
  },
  async created() {
    await this.context.prepareData()
    this.loadConfigData()
    getSopTemplateConfig({ lob: 'RE' }).then(res => {
      this.sopTemplateConfigRE = res.data
    })
    getSopTemplateConfig({ lob: 'RI' }).then(res => {
      this.sopTemplateConfigRI = res.data
    })
  },
  updated() {
    if (!this.$refs['tabs']) {
      return
    }
    const panes = this.$refs['tabs'].panes
    const tabNameSet = new Set()
    for (const item of panes) {
      tabNameSet.add(item.name)
    }
    // 将失效的tab名称从pendTabSet中移除
    for (const item of [...this.pendTabSet]) {
      if (!tabNameSet.has(item)) {
        this.pendTabSet.delete(item)
      }
    }
  },
  methods: {
    // 公用方法，进入详情每个页签都会调用
    async onShow(action, rowData, selectedRow) {
      this.loading = getLoading()
      this.selectedRow = selectedRow
      this.$store.dispatch('app/setCanCloseModule', action === 'look')
      this.action = action
      if (!this.activeTabName) {
        this.paramsOfTab.masterFlag = this.currentRow.masterFlag = selectedRow.masterFlag
      }
      /* 先将原始数据赋给currentRow、paramsOfTab，让页面先展示 */
      this.currentRow = selectedRow
      this.paramsOfTab = this.currentRow
      this.$nextTick(() => {
        this.resetActiveTabName()
      })
      this.isOtherEdit = action === 'split' || action === 'copy'
      this.action = action
      if (selectedRow.uuid) {
        this.rowData = rowData
      } else {
        if ((!selectedRow.lclNumber && !this.isOtherEdit)) {
          this.context.opDepartment = null
          await Promise.all([this.getDefaultJob(selectedRow.lob), this.context.getOpDepartment(this.office)])
          this.buildNewRow(selectedRow)
        }
        // CARGO-53866 东丽 新增业务 销售默认带入当前登录人
        await JobUtils.loadingDlwlSales(selectedRow, this)
        selectedRow.jobState = -1
        selectedRow.preverifyState = 1
        if (!Object.prototype.hasOwnProperty.call(selectedRow, 'path')) selectedRow.path = ''
        this.rowData = [...rowData, selectedRow]
      }
      this.$nextTick(async() => {
        if (this.gridApi) {
          await sleep(100)
        } else {
          // 等待gridApi被赋值
          await ensureExecuteSuccess(() => this.gridApi)
        }
        this.loading.close()
        this.setGridSelect(selectedRow)
        await this.onRowClicked({ data: selectedRow })
      })
      if (action === 'look') {
        const cfg = LocalStorageUtils.getConfiguration('RailwaySopStatusPopupVisible')
        this.sopStateDialog.visible = !!cfg
      }
    },
    // sop 双击事件
    onBtnListDoubleClicked() {
      LocalStorageUtils.setConfiguration('RailwaySopStatusPopupVisible', true)
      this.sopStateDialog.visible = true
      this.sopStateDialog.defaultIsExpand = true
      this.sopStateDialog.isNeedExpand = true
    },
    // sop 关闭处理
    sopStateDialogClose() {
      this.sopStateDialog.defaultIsExpand = true
      LocalStorageUtils.setConfiguration('RailwaySopStatusPopupVisible', false)
    },
    resetActiveTabName() {
      if (this.isNew) {
        this.activeTabName = this.getDefaultActiveName()
      } else {
        const activePanes = this.$refs['tabs'].panes.filter(p => p.active)
        if (activePanes && activePanes.length === 0) {
          this.activeTabName = this.getDefaultActiveName()
        }
      }
    },
    getDefaultActiveName() {
      const firstPane = this.$refs['tabs'].panes[0]
      return firstPane ? firstPane.name : ''
    },
    // 加载配置项
    loadConfigData() {
      this.creditRestrictionForBooking = parseInt(this.config.get('CreditRestrictionForBooking'))
      this.pretrialReviewConfig = parseInt(this.config.get('PretrialReviewRailway')) === 1
    },
    // 新增时，填充默认值
    buildNewRow(row) {
      // 填充默认值
      new RailwayExportJob(row).fillDefaultValue()
      if (!row.hasOwnProperty('lob') || !row.lob) {
        row.lob = 'RE'
      }
      row.cargoType = 'GC'
      row.cargoSource = 'NC'
      row.opOffice = this.office.officeId
      if (this.context.opDepartment && Number(this.context.opDepartment.departmentId) > 0) {
        row.op = this.user.userId
        if (this.user.defaultDepId > 0 && this.user.defaultOfficeId === this.office.officeId) {
          row.opDepartment = this.user.defaultDepId
        } else {
          row.opDepartment = this.context.opDepartment.departmentId
        }
      }
      if (row.masterFlag) {
        row.cargoSource = ''
        row.containerLoadType = 'LCL'
      } else {
        row.containerLoadType = 'FCL'
      }
      row.tradeTerm = '110'
      row.taxNature = 0
      Object.assign(row, this.defaultJob)
      if (row.masterFlag) {
        row.dispatchingPlace = ''
      }
    },
    // 设置选中行
    setGridSelect(row) {
      const nodes = this.gridApi.rowModel.rowsToDisplay
      for (const item of nodes) {
        if (!item.data) {
          continue
        }
        const itemKey = item.data.uuid || item.data.jobUuid
        const rowKey = row.uuid || row.jobUuid
        if (itemKey === rowKey || !itemKey) {
          this.gridApi.setFocusedCell(item.rowIndex, this.gridApi.columnController.getAllDisplayedColumns()[0])
          item.setData(item.data)
          break
        }
      }
    },
    // 左侧列表切换job
    async changeJob(event) {
      const result = event.data
      if (result) {
        // 重新数据库中加载job
        this.isGetNewJobInfoFromDb = true
        result.version = 0
        for (const key in result) {
          if (typeof result[key] === 'object') {
            result[key] = ''
          }
        }
        await this.onRowClicked({ data: result })
        // console.log('changeJob====', event.data, event.data.seaEQ, event.data.lclSlaves)
      }
    },
    // 行点击
    async onRowClicked(event) {
      this.loading = getLoading()
      if (!event.data) {
        this.loading.close()
        return
      }
      this.currentRow = event.data
      const jobVersion = event.data.version
      this.setGridSelect(this.currentRow)
      let loadCooperate = false
      // 加载job详细信息
      if (!this.currentRow.isCompleteRow || this.isGetNewJobInfoFromDb) {
        const jobModel = new RailwayExportJob(this.currentRow)
        if (this.currentRow.uuid) {
          if (!jobVersion || jobVersion === 0) this.currentRow.version = 0 // version为0时可以重新加载job
          await jobModel.loadJobRelated({
            job: !(jobModel.version >= 1), // 脏数据，需要重新载入
            seaEQ: true,
            lclSlaves: this.currentRow.masterFlag,
            lclMaster: !this.currentRow.masterFlag,
            charges: true,
            warehouseIn: true,
            warehouseInfo: true,
            trucking: true,
            containerUsages: true,
            containers: true,
            cargoBulkDetail: !this.currentRow.masterFlag,
            surchargeTerms: !this.currentRow.masterFlag,
            // railwayHeadwayTails: true 后续在页签内加载
            orderCenterMode: this.useOrderCenterMode,
            cooperateBranchId: this.cooperateBranchId
          })
          loadCooperate = true
          // 非主票 组装 containers.containerUsage  同 job.containerUsages 指向同一usage
          if (!jobModel.masterFlag) {
            ContainerUtil.buildContainerUsages(this.currentRow)
          }
          if (!this.currentRow.path) {
            this.setBasicData(this.currentRow)
            this.gridApi.refreshCells({ force: true })
          }
        } else {
          jobModel.seaEQ = jobModel.seaEQ || []
          jobModel.lclSlaves = jobModel.lclSlaves || []
          jobModel.lclMaster = jobModel.lclMaster || null
          jobModel.charges = jobModel.charges || []
          jobModel.warehouseIn = jobModel.warehouseIn || []
          jobModel.warehouseInfo = jobModel.warehouseInfo || []
          jobModel.trucking = jobModel.trucking || []
          jobModel.containerUsages = jobModel.containerUsages || []
          jobModel.containers = jobModel.containers || []
          jobModel.cargoBulkDetail = jobModel.cargoBulkDetail || []
          jobModel.surchargeTerms = jobModel.surchargeTerms || []
          jobModel.railwayHeadwayTails = jobModel.railwayHeadwayTails || []
        }
        this.currentRow.isCompleteRow = true
        this.isGetNewJobInfoFromDb = false
        // console.log('onRowClicked====', this.currentRow, this.currentRow.seaEQ, this.currentRow.lclSlaves)
      }
      // 协作分公司信息
      if (this.useOrderCenterMode) {
        if (loadCooperate && this.currentRow.cooperate && this.currentRow.cooperate.uuid) {
          console.log('this.currentRow.cooperate===', this.currentRow.cooperate)
          // 记录原值
          this.currentRow.opOffice_original = this.currentRow.opOffice // 分公司
          this.currentRow.op_original = this.currentRow.op // 操作
          this.currentRow.csr_original = this.currentRow.csr // 客服
          this.currentRow.overseaOp_original = this.currentRow.overseaOp // 海外操作
          this.currentRow.dc_original = this.currentRow.dc // 单证
          this.currentRow.planner_original = this.currentRow.planner // 航线负责人
          this.currentRow.opDepartment_original = this.currentRow.opDepartment // 操作部门
          //
          this.currentRow.opOffice = this.currentRow.cooperate.branchId // 分公司
          this.currentRow.op = this.currentRow.cooperate.opId // 操作
          this.currentRow.csr = this.currentRow.cooperate.csrId // 客服
          this.currentRow.overseaOp = this.currentRow.cooperate.overseaOp // 海外操作
          this.currentRow.dc = this.currentRow.cooperate.dcId // 单证
          this.currentRow.planner = this.currentRow.cooperate.planner // 航线负责人
          this.currentRow.opDepartment = this.currentRow.cooperate.opDepartment // 操作部门
          JobUtils.convertJobFromCooperateInfo(this.currentRow, this.currentRow.cooperate)
          //
          this.currentRow.cooperateUuid = this.currentRow.cooperate.uuid
          this.currentRow.cooperateCooperateStatus = this.currentRow.cooperate.cooperateStatus
          this.currentRow.cooperateBusinessType = this.currentRow.cooperate.businessType
          this.currentRow.cooperateBranchId = this.currentRow.cooperate.branchId
          this.currentRow.cooperateOpId = this.currentRow.cooperate.opId
          this.currentRow.cooperateCsrId = this.currentRow.cooperate.csrId
          this.currentRow.cooperateOverseaOp = this.currentRow.cooperate.overseaOp
          this.currentRow.cooperateDcId = this.currentRow.cooperate.dcId
          this.currentRow.cooperatePlanner = this.currentRow.cooperate.planner
          this.currentRow.cooperateOpDepartment = this.currentRow.cooperate.opDepartment
          this.currentRow.cooperateSales = this.currentRow.cooperate.sales
          this.currentRow.cooperateCargoSalesId = this.currentRow.cooperate.cargoSalesId
          this.currentRow.cooperateUserDefinedRoleId1 = this.currentRow.cooperate.userDefinedRoleId1
          this.currentRow.cooperateUserDefinedRoleId2 = this.currentRow.cooperate.userDefinedRoleId2
        }
      }
      this.initInfo()
      this.resetParamsOfTab()
      this.pendTabSet.clear()
      this.context.modifiedData = {}
      this.processingPromiseList = []
      this.$nextTick(() => {
        if (this.isNew) {
          this.activeTabName = this.getDefaultActiveName()
        } else {
          const activePanes = this.$refs['tabs'].panes.filter(p => p.active)
          if (activePanes && activePanes.length === 0) {
            this.activeTabName = this.getDefaultActiveName()
          }
        }
        this.handleTabClick()
      })
    },
    resetParamsOfTab() {
      this.paramsOfTab = {}
      if (this.action === 'edit') {
        this.paramsOfTab = deepCopy(this.currentRow)
      } else {
        this.paramsOfTab = this.currentRow
        console.log('this.paramsOfTab==========', this.paramsOfTab)
      }
    },
    beforeLeaveTab(activeName, oldActiveName) {
      if (oldActiveName) {
        this.endTabHandler(oldActiveName)
      }
      return true
    },
    // tab页签结束后的处理
    async endTabHandler(tabName) {
      const tab = this.$refs[tabName]
      if (!tab) {
        return
      }
      if (tab.endTabHandler && typeof tab.endTabHandler === 'function') {
        const result = tab.endTabHandler()
        if (result instanceof Promise) {
          await result
        }
      }
    },
    // tab页签切换
    handleTabClick() {
      this.loading = getLoading()
      this.$nextTick(() => {
        const oldSize = this.pendTabSet.size
        this.pendTabSet.add(this.activeTabName)
        const isRefresh = this.pendTabSet.size > oldSize
        // this.$logger.log('handleTabClick-isRefresh', isRefresh)
        this.$refs[this.activeTabName].onShow(this.paramsOfTab, isRefresh)
        this.loading.close()
      })
    },
    // 编辑
    editHandler(action) {
      this.loading = getLoading()
      new Promise((resolve) => {
        setTimeout(() => {
          resolve()
        }, 150)
      }).then(async() => {
        if (this.currentRow.jobState !== 0) {
          this.$message.info(this.$t('Message.ThisJobIsNotWorkingCanNotBeEdited'))
          this.loading.close()
          return
        }
        if (!await SecurityUtil.canEdit(this.currentRow)) {
          this.$message.info(this.$t('Message.NoPermissionToEditTheJob'))
          this.loading.close()
          return
        }
        this.againShow(action)
      })
    },
    // 合并数据
    againShow(action, row) {
      this.action = action
      this.loading = getLoading()
      const selectedRow = this.isNew ? row || {} : this.currentRow
      this.onShow(action, this.rowData, selectedRow)
    },
    // 保存海运业务【保存业务相关数据】
    async save() {
      if (this.processingPromiseList.length > 0) {
        const processingPromiseList = [...this.processingPromiseList]
        for (const processingPromise of processingPromiseList) {
          try {
            await processingPromise
          } catch (err) {
            console.log(err)
          }
        }
      }
      // 当前页签结束后的处理
      if (this.activeTabName) {
        await this.endTabHandler(this.activeTabName)
      }
      const body = {}
      try {
        for (const item of [...this.pendTabSet, 'other']) {
          let tabData = null
          if (item !== 'other') {
            // 各页签的保存数据
            const getSubmitData = this.$refs[item].getSubmitData
            if (getSubmitData && typeof getSubmitData === 'function') {
              /* 获取各页签需要保存的数据 */
              const result = this.$refs[item].getSubmitData()
              if (result instanceof Promise) {
                tabData = await result
              } else {
                tabData = result
              }
            }
          } else {
            // 被联动修改了的数据
            tabData = this.context.modifiedData
          }

          if (!tabData) continue
          // this.$logger.log('tabData' + item, tabData)
          // 将不同页签相同key的集合进行数据合并
          for (const key in tabData) {
            const tabValue = tabData[key]
            // this.$logger.log('tabValue：' + item, tabValue)
            if (!tabValue) continue // 判断当前页签所传的数据是否有效，无效则不需要合并
            const bodyValue = body[key]
            // this.$logger.log('bodyValue：' + item, bodyValue)
            if (!bodyValue || !Object.prototype.hasOwnProperty.call(body, key)) continue // 判断body中是否存在该key，不存在或者无数据则由下面统一合并
            // 将数组进行合并
            if (Array.isArray(tabValue)) {
              //
              if (Array.isArray(bodyValue)) { // 这里面会将 uuid 相同的费用进行过滤，页签上的优先于 级联改动的数据
                const bodyMap = new Map()
                if (bodyValue && bodyValue.length > 0) {
                  for (const bodyKey of bodyValue) {
                    if (!bodyKey) continue
                    if (Object.prototype.hasOwnProperty.call(bodyKey, 'uuid') && bodyKey.uuid) bodyMap.set(bodyKey.uuid, bodyKey)
                  }
                }
                if (tabValue && tabValue.length > 0) {
                  for (const tabKey of tabValue) {
                    if (!tabKey || bodyValue.includes(tabKey)) continue
                    if (Object.prototype.hasOwnProperty.call(tabKey, 'uuid') && tabKey.uuid && bodyMap.has(tabKey.uuid)) continue
                    bodyValue.push(tabKey)
                  }
                }
              } else {
                tabValue.push(bodyValue)
                body[key] = tabValue
              }
              delete tabData[key]
            }
          }
          Object.assign(body, tabData)
          // this.$logger.log('页签名称：' + item, tabData)
        }
        // 还原接单分公司
        if (this.useOrderCenterMode) {
          if (body.job && body.job.cooperateUuid) {
            body.job.opOffice = body.job.opOffice_original || body.job.opOffice // 分公司
            body.job.op = body.job.op_original || body.job.op // 操作
            body.job.csr = body.job.csr_original || body.job.csr // 客服
            body.job.overseaOp = body.job.overseaOp_original || body.job.overseaOp // 海外操作
            body.job.dc = body.job.dc_original || body.job.dc // 单证
            body.job.planner = body.job.planner_original || body.job.planner // 航线负责人
            body.job.opDepartment = body.job.opDepartment_original || body.job.opDepartment // 操作部门
            JobUtils.restoreJobFromCooperateInfo(body.job)
          }
        }
        // 复制、拆分主票保存前处理【未点击页签的数据也需要保存】
        this.doNotClickTabData(body)

        // 清空子表数据【原本是在各页签里面的，现在移到公共的地方来】
        if (Reflect.has(body, 'job') && body.job) {
          for (const key in body.job) {
            // 这里必须要删除，不能将其置为空或者undefined，否则复制或者拆分主票没法赋值
            if (typeof body.job[key] === 'object') delete body.job[key]

            // 保存时需要将sop显示列排除
            if (key.indexOf('_sop_') !== -1 && key.startsWith('_sop_')) delete body.job[key]
          }
        }

        // 主票 新增/加入小票 使用
        if (this.currentRow.lclNumber) {
          const job = this.currentRow
          if (job.warehouseInfo) {
            Object.assign(body, { warehouseInfo: job.warehouseInfo })
          }
          if (job.trucking) {
            Object.assign(body, { truckingInfo: job.trucking })
          }
        }
        this.cleanCircleObject(body)
        this.$logger.log('body', body)
        JobUtils.handleChargeForSave(body)
      } catch (err) {
        this.loading.close()
        if (err instanceof TabError) {
          this.activeTabName = err.tabName
          if (err.message) {
            this.$message.warning({ dangerouslyUseHTMLString: true, message: err.message })
          }
          return
        }
        throw err
      }
      // 在保存前进行校验
      const bodyJob = body.job || null
      if (!(await this.pm.checkBeforeSave(bodyJob))) {
        this.loading.close()
        return
      }

      // 获取复制份数
      if (Reflect.has(body, 'job') && Reflect.has(body.job, 'copyNum') && Number(body.job.copyNum) > 1) {
        this.copyJobNum = Number(body.job.copyNum)
      }

      // 后端触发SOP使用
      if (!this.isNew) body.jobUuid = this.job.uuid

      // 保存 访问数据库
      // 拆分主票 保存处理逻辑【也走这里】
      body.action = this.action
      this.loading = getLoading() // 这个loading要放在验证之后
      await saveRailwayExport(body).then(res => {
        const result = res.data.job
        if (result) {
          Object.assign(this.currentRow, result)
          this.currentRow.version = 0
          this.currentRow.blocked = result.blocked
          this.currentRow.jobUuid = result.uuid
          this.currentRow.dataType = result.masterFlag ? 1 : 2 // 1、主票 1、小票
          if (this.currentRow.lclMasterUuid) {
            this.currentRow.path = result.lclMasterUuid + ',' + result.uuid
          } else {
            this.currentRow.path = result.uuid
          }
          this.isRefresh = true
        }
        // 重置子表数据【将job相关信息置空，然后从库里重新加载】
        for (const key in this.currentRow) {
          if (typeof this.currentRow[key] === 'object') {
            this.currentRow[key] = ''
          }
        }
        this.currentRow.isCompleteRow = false
        const lclSlaves = body.lclSlaves // 先将拆分主票对应的小票记录，保存后使用
        if (this.action === 'split' && lclSlaves && lclSlaves.length > 0) {
          if (!this.currentRow.beSplitedLclUuids) {
            this.currentRow.beSplitedLclUuids = Array.from(lclSlaves, p => p.uuid)
          }
          // 原被拆分的主票uuid集合
          const oldMasterUuidSet = new Set()
          // 更新小票
          const rows = this.rowData.filter(p => this.currentRow.beSplitedLclUuids.includes(p.uuid))
          for (const lcl of rows) {
            oldMasterUuidSet.add(lcl.lclMasterUuid)
            lcl.isCompleteRow = false
            lcl.parentUuid = this.currentRow.uuid
            lcl.lclMasterUuid = this.currentRow.uuid
            lcl.path = this.currentRow.uuid + ',' + lcl.uuid
            lcl.version = 0 // 标识为脏数据，需要重新载入
          }
          this.gridApi.setRowData(this.rowData)
          // 原被拆分的主票，需重新加载
          const oldMasterJobs = this.rowData.filter(p => oldMasterUuidSet.has(p.uuid))
          for (const item of oldMasterJobs) {
            item.isCompleteRow = false
            item.version = 0 // 标识为脏数据，需要重新载入
            // 重置子表数据
            for (const key in item) {
              if (typeof item[key] === 'object') {
                item[key] = ''
              }
            }
          }
        }
      })
      // console.log('this.rowData===', this.rowData)
      // 复制多份业务，保存的处理逻辑
      if (this.copyJobNum > 1 && this.currentRow.uuid) {
        await this.saveCopyJobHandle(this.currentRow.uuid, this.copyJobNum - 1)
      }

      // 主票页签新增多个小票，保存的处理逻辑
      if (this.currentRow.lclNumber && this.currentRow.uuid) {
        const job = this.currentRow
        // 更新新增的第一条小票数据
        job.jobUuid = job.uuid
        job.parentUuid = job.lclMasterUuid
        job.path = job.lclMasterUuid + ',' + job.uuid
        job.dataType = 2 // 小票
        if (job.lclNumber > 1) {
          await this.saveLclJob(job.uuid, job.lclNumber - 1)
        } else {
          this.rowData = [...this.rowData, { ...job }]
        }
        delete job.lclNumber
        // 切换回主票
        this.currentRow = this.rowData.find(p => p.uuid === job.lclMasterUuid)
        this.currentRow.version = 0
        // 重置子表数据【将job相关信息置空，然后从库里重新加载】
        for (const key in this.currentRow) {
          if (typeof this.currentRow[key] === 'object') {
            this.currentRow[key] = ''
          }
        }
      }

      // 保存成功后各业签执行的回调方法
      for (const item of this.pendTabSet) {
        const executeTask = this.$refs[item].executeTask
        if (executeTask && typeof executeTask === 'function') {
          /* 保存成功后的回调 */
          const result = this.$refs[item].executeTask()
          if (result instanceof Promise) {
            await result
          }
        }
      }
      this.loading.close()
      this.isGetNewJobInfoFromDb = true
      this.againShow('look', this.currentRow)
      if (this.currentRow.blocked && !this.currentRow.specialApproval) {
        // 保存成功之后如果是信控锁住则会弹此提示【Job.as 中的 save方法】
        setTimeout(() => {
          this.$message.warning(this.$t('SeaExport.CheckCreditSaveTip'))
        }, 2000)
      }
      this.$message.success(this.$t('Message.SaveSuccessfully'))
      this.copyJobNum = 0

      // 保存业务触发SOP后需要刷新 SOP操作状态弹框
      if (this.sopStateDialog.visible) {
        setTimeout(() => {
          this.sopStateDialog.isNeedRefresh = true
        }, 3000)
      }
    },
    // 复制、拆分主票保存前处理【未点击页签的数据也需要保存】
    doNotClickTabData(body) {
      const isCopy = this.action === 'copy'
      const isSplit = this.action === 'split'
      const job = this.currentRow
      if (!body || !job || (!isCopy && !isSplit)) return
      // 复制独有
      if (isCopy) {
        if (!Object.prototype.hasOwnProperty.call(body, 'warehouseInfo') && job.warehouseInfo && job.warehouseInfo.length > 0) {
          Object.assign(body, { warehouseInfo: job.warehouseInfo })
        }
        if (!Object.prototype.hasOwnProperty.call(body, 'trucking') && job.trucking && job.trucking.length > 0) {
          Object.assign(body, { truckingInfo: job.trucking })
        }
        if (!Object.prototype.hasOwnProperty.call(body, 'charges') && job.charges && job.charges.length > 0) {
          Object.assign(body, { charges: job.charges })
        }
      }

      // 拆分主票或者复制共有
      if (!Object.prototype.hasOwnProperty.call(body, 'seaEQ') && job.seaEQ && job.seaEQ.length > 0) {
        Object.assign(body, { seaEQ: job.seaEQ })
      }
      if (!Object.prototype.hasOwnProperty.call(body, 'containers') && job.containers && job.containers.length > 0) {
        Object.assign(body, { containers: job.containers })
      }

      // 拆分主票独有
      if (isSplit) {
        if (!Object.prototype.hasOwnProperty.call(body, 'lclSlaves') && job.lclSlaves && job.lclSlaves.length > 0) {
          Object.assign(body, { lclSlaves: job.lclSlaves })
        }

        // todo 目前处理了从主票装箱拆分入口 被拆分主票的container,seqEq 信息
        if (job.sourceSeqEq) {
          if (job.sourceSeqEq.delseaEQUuids) {
            body.delseaEQUuids = job.sourceSeqEq.delseaEQUuids.join(',')
          }
          if (job.sourceSeqEq.updateSeaEq && job.sourceSeqEq.updateSeaEq.length > 0) {
            if (!body.seaEQ) {
              body.seaEQ = []
            }
            body.seaEQ.push(...job.sourceSeqEq.updateSeaEq)
          }
        }
      }

      // containerUsages 的保存跟随 containers
      /* if (!Object.prototype.hasOwnProperty.call(body, 'containerUsages') && job.containerUsages && job.containerUsages.length > 0) {
        Object.assign(body, { containerUsages: job.containerUsages })
      }*/
    },
    // 清理循环引用
    cleanCircleObject(obj, level = 0, refMap = new Map()) {
      if (!(obj instanceof Object)) {
        return
      }
      if (level === 0) {
        refMap.set(obj, { level })
      }
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const item = obj[key]
          if (item instanceof Object) {
            const ref = refMap.get(item)
            if (ref) {
              if (level > ref.level) {
                if (obj instanceof Array) {
                  obj[key] = undefined
                } else {
                  delete obj[key]
                }
              } else if (level < ref.level) {
                if (ref.parent instanceof Array) {
                  ref.parent[ref.name] = undefined
                } else {
                  delete ref.parent[ref.name]
                }
                ref.level = level
                ref.parent = obj
                ref.name = key
              }
            } else {
              refMap.set(item, { level: level + 1, parent: obj, name: key })
              this.cleanCircleObject(item, level + 1, refMap)
            }
          }
        }
      }
      if (level === 0) {
        for (const arr of refMap.keys()) {
          if (arr instanceof Array) {
            // 从后向前删除，避免待删除元素的index发生变化
            for (let i = arr.length - 1; i >= 0; --i) {
              if (typeof arr[i] === 'undefined') {
                arr.splice(i, 1)
              }
            }
          }
        }
      }
    },
    // 保存剩下的复制业务【后台复制并保存】
    async saveCopyJobHandle(jobUuid, copyNum) {
      const item = {}
      item.jobUuid = jobUuid
      item.branchId = this.$store.getters.currentOfficeId
      // 复制哪些页签的数据
      const lob = this.currentRow.lob
      item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob)
      item.copyNum = copyNum
      item.all = true
      item.copyOnly = true // 是否是复制业务，新增业务日志时使用
      await saveCopyJob(item).then(res => {
        const newJobList = res.data
        if (newJobList && newJobList.length > 0) {
          for (const copyJob of newJobList) {
            this.setBasicData(copyJob)
          }
          this.rowData = [...this.rowData, ...newJobList]
        }
        JobUtils.copyFailTip(copyNum, newJobList, this)
      })
    },
    // 给job设置基本信息
    setBasicData(jobData) {
      jobData.jobUuid = jobData.uuid
      jobData.parentUuid = jobData.uuid
      jobData.path = jobData.uuid
      jobData.dataType = 2 // 小票
    },
    // 保存剩下的新增小票业务【后台复制并保存】
    async saveLclJob(jobUuid, copyNum) {
      const item = {
        jobUuid,
        masterJobNo: this.currentRow.masterJobNo || '',
        branchId: this.$store.getters.currentOfficeId,
        copyNum,
        all: true,
        copyOnly: false // 是否是复制业务，新增业务日志时使用
      }
      await saveCopyJob(item).then(res => {
        const newJobList = res.data
        if (newJobList && newJobList.length > 0) {
          for (const copyJob of newJobList) {
            this.setBasicData(copyJob)
            copyJob.jobUuid = copyJob.uuid
            copyJob.parentUuid = copyJob.lclMasterUuid
            copyJob.path = copyJob.lclMasterUuid + ',' + copyJob.uuid
            copyJob.dataType = 2 // 小票
          }
          this.rowData = [...this.rowData, ...newJobList]
        }
        JobUtils.copyFailTip(copyNum, newJobList, this)
      })
    },
    // 取消编辑
    cancelEdit(done) {
      this.$confirm(this.$t('CargoMsg.Cargo_CCOCM'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        if (typeof done === 'function') {
          done()
        }
      }).catch(() => { })
    },
    // 刷新
    refresh() {
      this.isGetNewJobInfoFromDb = true
      this.againShow(this.action, this.job)
    },
    // 加载完job走这里
    initInfo() {
      this.showJobState()
      this.showJobTitle()
    },
    // 业务状态显示
    showJobState() {
      if (!this.currentRow || !this.currentRow.uuid) {
        this.commonInfo.jobState = ''
        this.commonInfo.jobLock = ''
        this.commonInfo.jobChangeState = ''
        return
      }
      this.commonInfo.jobState = ColumnUtils.getJobState(this.currentRow)
      this.commonInfo.jobLock = (this.currentRow.blocked && !this.currentRow.specialApproval) ? this.$t('Message.Locked') : ''
      // 改单状态
      if (Number(this.config.get('IsCommittedAllowAddCost')) === 1) {
        this.commonInfo.jobChangeState = ColumnUtils.getJobChangeState(this.currentRow)
      }
    },
    async showJobTitle() {
      const job = this.currentRow
      let jobTitle = job.jobNo
      if (job.customerId) {
        const cmp = this.context.companyList.find(p => p.cmpIdx === job.customerId)
        if (cmp) {
          const creditTerm = await JobUtils.getSettlementTypeByJobInformation(job, 'customerId')
          const billingType = await Company.loadCustomer(cmp.uuid).then(data => {
            const customerDetail = data.length > 0 ? data[0] : null
            if (customerDetail) {
              const str1 = ` ${this.$t('Message.BillingType')}[${this.$t('Message.ByTicket')}]`
              const str2 = `${this.$t('Message.BillingType')}[${this.$t('Message.Monthly')}]`
              return customerDetail.invoiceMode === 0 ? str1 : str2
            }
            return ''
          })
          jobTitle = '<span style="margin-right:10px">' + jobTitle + '</span><span style="margin-right:10px">' + cmp.chineseName + creditTerm + '</span><span>' + billingType + '</span>'
        }
      }
      this.commonInfo.jobTitle = jobTitle
    },
    goBack() {
      this.$emit('back', this.isRefresh)
      setTimeout(() => {
        this.activeTabName = ''
        this.action = ''
        this.$store.dispatch('app/setCanCloseModule', true)
      }, 500)
    },
    // 查看
    lookHandler() {
      this.againShow('look', this.currentRow)
    },
    // 合并当前job【刷新当前job】
    mergeCurrentRow(res) {
      if (res && res.data) {
        Object.assign(this.currentRow, res.data)
        this.currentRow.uuid = res.data.uuid
        this.isGetNewJobInfoFromDb = true
        this.isRefresh = true
      }
    },
    // 根据对象的属性排序[descending 是否降序]
    createComparisonFunction(propertyName, descending = false) {
      return function(object1, object2) {
        const value1 = object1[propertyName]
        const value2 = object2[propertyName]

        if (!descending) {
          return value1 - value2
        } else {
          return value2 - value1
        }
      }
    },
    // 验证规则配置公用
    async checkingManager(checkNode, callBack, callBack2, newJob = null) {
      this.$logger.log('this.job', this.job)
      if (!this.job) return
      let checkType = true
      if (this.job.masterFlag) {
        const lclSlaves = await new RailwayExportJob(this.job).getLclSlaves()
        if (lclSlaves && lclSlaves.length > 0) { // 批量验证
          checkType = false
          this.batchCheckingWindow.checkNode = checkNode
          this.batchCheckingWindow.jobs = [this.job, ... lclSlaves]
          this.batchCheckingWindow.callBack = callBack
          this.batchCheckingWindow.callBack2 = callBack2
          this.batchCheckingWindow.newJob = newJob
          this.batchCheckingWindow.visible = true
        }
      }
      if (checkType) { // 单个验证
        this.checkingWindow.checkNode = checkNode
        this.checkingWindow.callBack = callBack
        this.checkingWindow.callBack2 = callBack2
        this.checkingWindow.newJob = newJob
        this.checkingWindow.visible = true
      }
    },
    addBatchLcl(lclJob) {
      lclJob.path = ''
      console.log('addBatchLcl')
      console.log(lclJob)
      this.onShow('add', this.rowData, lclJob)
    },
    transferTargetRow(action, jobUuid) {
      const selectedRow = this.rowData.find(p => p.uuid === jobUuid)
      if (selectedRow) {
        this.onShow(action, this.rowData, selectedRow)
      }
    },
    // 加入小票
    addSlavedJob(jobs) {
      for (const job of jobs) {
        job.jobUuid = job.uuid
        job.parentUuid = job.lclMasterUuid
        job.path = job.lclMasterUuid + ',' + job.uuid
        job.dataType = 2 // 小票
        const oldIndex = this.rowData.findIndex(p => p.uuid === job.uuid)
        if (oldIndex >= 0) {
          this.rowData.splice(oldIndex, 1)
        }
      }
      this.rowData = [...this.rowData, ...jobs]
      this.$nextTick(() => {
        this.setGridSelect(this.currentRow)
      })
    },
    // 移除小票
    removeJobFromMaster(jobKeys) {
      const rows = this.rowData.filter(p => !jobKeys.includes(p.uuid))
      this.rowData = [...rows]
      this.$nextTick(() => {
        this.setGridSelect(this.currentRow)
      })
    },
    removeJob(jobUuid) {
      const rows = this.rowData.filter(p => p.uuid !== jobUuid)
      this.rowData = [...rows]
      this.$nextTick(() => {
        this.setGridSelect(this.currentRow)
      })
      this.currentRow.version = 0
      this.refresh()
    },
    splitHandle(row) {
      this.view = 'detail'
      this.onShow('split', this.rowData, row)
    },
    resetSopTooltip(event) {
      this.sopTooltipOffset = event.offsetX
    },
    resetTab(tabName) {
      this.pendTabSet.delete(tabName)
    },
    syncData(data) {
      Object.assign(this.currentRow, data)
    },
    reload() {
      this.currentRow.version = 0
      this.isRefresh = true
      // 重置子表数据
      for (const key in this.currentRow) {
        if (typeof this.currentRow[key] === 'object') {
          this.currentRow[key] = ''
        }
      }
      this.isGetNewJobInfoFromDb = true
      this.againShow(this.action, this.currentRow)
    },
    // 新增
    onAdd() {
      this.$emit('add')
    },
    // 编辑
    toEdit() {
      if (!this.currentRow) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      // 协作状态
      if (this.currentRow.cooperateStatus !== -1 && this.useOrderCenterMode && !this.orderCenterBranch && this.approveCooperationBusiness) {
        if (this.currentRow.cooperateStatus !== SystemConstants.COOPERATE_STATUS_APPROVED.code) {
          const cooperateStatusStr = JobUtils.getStateName(this.currentRow.cooperateStatus, SystemConstants.COOPERATE_STATUS)
          this.$message.warning(this.$t('Message.CanNotEditJob', [this.$t('CargoMsg.Cargo_CooperateStatus') + cooperateStatusStr]))
          return
        }
      }
      this.$emit('edit', this.currentRow)
    },
    // 复制
    copyJobHandler() {
      if (!this.currentRow) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.$emit('copy', this.currentRow)
    },
    // 审核通过
    acceptHandler(type) {
      if (!this.currentRow) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.opVerifyFrameDialog.type = type
      this.opVerifyFrameDialog.batchPassAudit = false
      this.opVerifyFrameDialog.job = this.currentRow
      const jobLists = []
      jobLists.push(this.currentRow)
      this.opVerifyFrameDialog.jobList = jobLists

      this.opVerifyFrameDialog.submitCallBack = this.acceptSubmitCallBack
      this.opVerifyFrameDialog.visible = true
    },
    acceptSubmitCallBack(result) {
      this.batchJobList = []
      this.opVerifyFrameDialog.result = result
      if (this.opVerifyFrameDialog.jobList.length === 1) {
        this.batchJobList.push(this.opVerifyFrameDialog.job)
      }
      const jobKeys = Array.from(this.batchJobList, p => p.uuid)
      const callBack = () => { batchCheckJobsCredit(jobKeys).then(res => this.checkCreditResultHandler(res)) }
      // 判断是否开启验证规则
      const checkNode = CheckRuleConstants.NODE_BOOKING_VERIFY.code
      const useCheckRule = Number(this.config.get('useCheckRule')) === 1
      if (useCheckRule) {
        // const hasCheckRule = await JobUtils.hasConfigCheckRule(checkNode, this.job.uuid, this.job.lob)
        const hasCheckRule = true
        if (hasCheckRule) {
          this.checkingManager(checkNode, callBack, null, result)
        } else {
          callBack()
        }
      } else {
        callBack()
      }
    },
    // 信控验证返回结果
    checkCreditResultHandler(res) {
      const result = res.data
      if (result && this.creditRestrictionForBooking !== 0) {
        if (this.creditRestrictionForBooking === 2) {
          this.confirmDialogWindow.messageTitle = this.$t('SeaExport.CheckCreditTipOne')
          this.confirmDialogWindow.content = result
          this.confirmDialogWindow.showConfirmBtn = false
          this.confirmDialogWindow.confirmCallBack = null
          this.confirmDialogWindow.visible = true
          return
        }
        if (this.creditRestrictionForBooking === 1) {
          this.confirmDialogWindow.messageTitle = this.$t('SeaExport.CheckCreditTipTwo')
          this.confirmDialogWindow.content = result
          this.confirmDialogWindow.showConfirmBtn = true
          this.confirmDialogWindow.confirmCallBack = this.batchAudit
          this.confirmDialogWindow.visible = true
          return
        }
      }
      this.batchAudit()
    },
    // 审核通过
    batchAudit() {
      // 订舱预审-审核通过类型
      let verifyType = 0 // 以下接口统一放在后端区分了
      if (this.batchJobList.length === 1) {
        verifyType = 1
      }
      if (verifyType === 0) {
        verifyType = 3
      }
      const result = this.opVerifyFrameDialog.result
      const jobKeys = Array.from(this.batchJobList, p => p.uuid)
      if (result) {
        result.jobKeys = jobKeys
        result.verifyType = this.opVerifyFrameDialog.verifyType = verifyType
        result.jobState = 0
        result.preverifyState = 2
      }
      this.loading = getLoading()
      approved(result, this.$store.getters.currentOfficeId).then(res => this.approvedResultHandler(res)).finally(() => {
        this.loading.close()
      })
    },
    approvedResultHandler(res) {
      if (res && res.data) Object.assign(this.opVerifyFrameDialog.job, res.data)
      const verifyType = this.opVerifyFrameDialog.verifyType
      switch (verifyType) {
        case 1:
        case 2:
          this.$message.success(this.$t('SeaExport.AuditSuccess'))
          this.refresh()
          break
        case 3:
        case 4:
          this.$message.success(this.$t('SeaExport.BatchAuditSuccess'))
          this.refresh()
          break
        default:
          break
      }
    },
    // 审核拒绝
    rejectHandler(type) {
      if (!this.currentRow) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.rejectWindow.type = type
      this.rejectWindow.jobNo = this.currentRow.jobNo
      this.rejectWindow.rejectCallBack = this.isCooperate ? this.rejectCooperateCallBackHandler : this.rejectCallBackHandler
      this.rejectWindow.visible = true
    },
    rejectCallBackHandler(remark) {
      this.loading = getLoading()
      preVerifyReject(this.currentRow.uuid, remark, 3).then(res => this.preVerifyRejectResultHandler(res)).finally(() => {
        this.loading.close()
      })
    },
    preVerifyRejectResultHandler(res) {
      if (res && res.data) Object.assign(this.currentRow, res.data)
      this.$message.success(this.$t('SeaExport.RefuseSuccess'))
      this.refresh()
    },
    // 复核通过
    btVerifyReviewThroughHandler(type) {
      if (!this.currentRow) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      // 详情单个复核
      const result = {}
      result.jobKeys = [this.currentRow.uuid]
      result.verifyType = 5
      result.jobState = 0
      result.preverifyState = 5
      this.loading = getLoading()
      approved(result, this.$store.getters.currentOfficeId).then(res => {
        Object.assign(this.currentRow, res.data)
        this.$message.success(this.$t('SeaExport.ReviewSuccess'))
        this.refresh()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 复核拒绝
    btVerifyReviewRefusalHandler(type) {
      if (!this.currentRow) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.loading = getLoading()
      preVerifyReject(this.currentRow.uuid, '', 6).then(res => {
        if (res && res.data) Object.assign(this.currentRow, res.data)
        this.$message.success(this.$t('SeaExport.ReviewRejectedSuccess'))
        if (type === 1) { // 详情审核通过
          this.$emit('refresh', this.currentRow)
        } else {
          this.toQuery()
          this.currentRow = null
          this.gridApi.clearFocusedCell()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 日志记录
    logHandle() {
      if (!this.currentRow.uuid) {
        return
      }
      switch (this.logCommand) {
        case this.$t('SeaExport.PortDataPushLog'):
          this.toQueryDataPushLog()
          break
        case this.$t('CargoMsg.Cargo_BusinessStatusChangeLog'):
          this.businessStatusDialog.visible = true
          break
        case this.$t('SeaExport.EdiStatusChangeLog'):
          this.ediStatusLogDialog.visible = true
          break
      }
    },
    async toQueryDataPushLog() {
      await new RailwayExportJob(this.currentRow).loadPushHistoryLogs()
      const item = this.currentRow.pushHistoryLogs
      const dataPushDialog = this.dataPushDialog
      dataPushDialog.titles = []
      dataPushDialog.dataMap = new Map()
      if (item) {
        const dataArr = []
        for (const k in item) {
          dataArr.push({ 'time': k, 'logs': item[k] })
        }
        // 排序 按时间降序
        sortByMultiField(dataArr, ['time'], true)
        if (dataArr && dataArr.length > 0) {
          for (const data of dataArr) {
            const logs = data.logs
            const firstLog = logs[0]
            let t = '：' + this.view.$t('SeaExport.DataPush')
            if (Number(firstLog.sourceType) === 1) {
              t = '：' + this.view.$t('SeaExport.MasterTicketSync')
            } else if (Number(firstLog.sourceType) === 2) {
              t = '：G7' + this.view.$t('SeaExport.DataPush')
            }
            const labTime = new Date(Number(data.time))
            const title = DateUtils.formatStandardDateTime(labTime) + t
            dataPushDialog.titles.push(title)
            const cMap = {}
            let labLog = ''
            const titleVals = []
            for (const h of logs) {
              if (!cMap.hasOwnProperty(h.fieldName + h.targetValue)) {
                if (!h.sourceValue || h.targetValue === h.sourceValue) {
                  labLog = h.fieldName + '：' + this.$t('CargoMsg.Cargo_NewValue') + '->' + h.targetValue
                } else {
                  const newValArr = h.targetValue ? h.targetValue.split(' ') : []
                  labLog = h.fieldName + '：' + this.$t('CargoMsg.Cargo_OriginalValue') + '->' + h.sourceValue + this.$t('CargoMsg.Cargo_NewValue') + '->' + (newValArr && newValArr.length > 0 ? newValArr[0] : '')
                  if (newValArr && newValArr.length > 0) {
                    for (const str of newValArr) {
                      const index = newValArr.indexOf(str)
                      if (index > 0) titleVals.push(str)
                    }
                  }
                }
                // 每一行便是一个div[ labLog -> div]
                titleVals.push(labLog)
              }
              if (h.fieldName === '箱种' || h.fieldName === this.view.$t('SeaExport.ContainerSize')) {
                cMap[h.fieldName + h.targetValue] = h.fieldName + h.targetValue
              }
            }
            dataPushDialog.dataMap.set(title, titleVals)
          }
        }
      }
      dataPushDialog.visible = true
    },
    refreshCharges() {
      const jobModel = new RailwayExportJob(this.paramsOfTab)
      if (jobModel.uuid) {
        jobModel.charges = ''
        const loading = getLoading4Cxt(this)
        jobModel.loadJobRelated({ charges: true }).finally(() => {
          loading.close()
        })
      }
    },
    // 协作状态: 审核通过
    acceptCooperateHandler(type) {
      if (!this.currentRow) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.cooperationVerifyDialog.jobUuid = this.currentRow.uuid
      const cooperate = {
        uuid: this.currentRow.cooperateUuid,
        branchId: this.currentRow.cooperateBranchId,
        opId: this.currentRow.cooperateOpId,
        csrId: this.currentRow.cooperateCsrId,
        overseaOp: this.currentRow.cooperateOverseaOp,
        dcId: this.currentRow.cooperateDcId,
        planner: this.currentRow.cooperatePlanner,
        sales: this.currentRow.cooperateSales,
        cargoSalesId: this.currentRow.cooperateCargoSalesId,
        userDefinedRoleId1: this.currentRow.cooperateUserDefinedRoleId1,
        userDefinedRoleId2: this.currentRow.cooperateUserDefinedRoleId2,
        opDepartment: this.currentRow.cooperateOpDepartment,
        businessType: this.currentRow.cooperateBusinessType ? this.currentRow.cooperateBusinessType.split(',') : [],
        cooperateStatus: this.currentRow.cooperateCooperateStatus
      }
      console.log('cooperate', cooperate)
      this.cooperationVerifyDialog.cooperate = cooperate
      this.cooperationVerifyDialog.editable = false
      this.cooperationVerifyDialog.visible = true
    },
    toAcceptCooperationVerifyCallBack(remark) {
      this.loading = getLoading()
      updateState({ jobUuid: this.currentRow.uuid, branchId: this.$store.getters.currentOffice.officeId,
        statusType: SystemConstants.STATUSTYPE_COOPERATE.code,
        status: SystemConstants.COOPERATE_STATUS_APPROVED.code,
        remark: remark }).then(res => {
        if (res && res.data) {
          this.currentRow.cooperateStatus = res.data[0].cooperateStatus
          this.$message.success(this.$t('SeaExport.AuditSuccess'))
          this.refresh()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 协作状态: 拒绝
    rejectCooperateCallBackHandler(remark) {
      this.loading = getLoading()
      updateState({ jobUuid: this.currentRow.uuid, branchId: this.$store.getters.currentOffice.officeId,
        statusType: SystemConstants.STATUSTYPE_COOPERATE.code,
        status: SystemConstants.COOPERATE_STATUS_REFUSED.code,
        remark: remark }).then(res => {
        if (res && res.data) {
          this.currentRow.cooperateStatus = res.data[0].cooperateStatus
          this.$message.success(this.$t('SeaExport.RefuseSuccess'))
          this.refresh()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    async getDefaultJob(lob) {
      const entityDefValUtil = EntityDefaultValueUtil.getInstance()
      if (!entityDefValUtil.defaultValues) {
        await entityDefValUtil.initEntityDefaultValue()
      }
      if (!lob || lob === 'RE') {
        this.defaultJob = entityDefValUtil.railwayExportJob.getData()
      } else {
        this.defaultJob = entityDefValUtil.railwayImportJob.getData()
      }
    },
    saveDefaultVal() {
      const loading = getLoading4Cxt(this)
      EntityDefaultValueUtil.getInstance().saveEntityDefaultValue(['Job', 'RailwayExportJob'], this.paramsOfTab).then(() => {
        this.$message.success(this.$t('Message.DefaultValuesAreSavedSuccessfully'))
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>
